import React from 'react';
import { themeStore } from 'Models/ThemeStore';
import { formatCurrency } from 'Util/_HumanWritten/CurrencyUtils';
import { stringIsEmpty, stringNotEmpty } from 'Util/TypeGuards';
import { HexToRgb } from 'Views/Components/Helpers/ColoursHelper';
import If from 'Views/Components/If/If';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';
import { CustomTooltip } from 'Views/Components/_HumanWritten/CustomTooltip/CustomTooltip';

export interface AddOnOptionCardProps {
	name: string;
	iconName?: string;
	colour?: string;
	staticPrice?: number;
	information?: string;
	removable?: boolean;
	removalTitle?: string;
	removalInformation?: string;
	displayInfoInTooltip?: boolean;
	children?: React.ReactNode;
}

export function AddOnOptionCard({
	name,
	iconName,
	colour,
	staticPrice,
	information,
	removable = true,
	removalTitle,
	removalInformation,
	displayInfoInTooltip,
	children,
}: AddOnOptionCardProps) {
	const rgb = HexToRgb(colour || '');
	const brandPrimary = HexToRgb(themeStore.config.brandColourPrimary);
	const iconBg = rgb
		? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.2)`
		: `rgba(${brandPrimary!.r}, ${brandPrimary!.g}, ${brandPrimary!.b}, 0.2)`;

	const tooltip = displayInfoInTooltip ? information : undefined;

	return (
		<div className="add-on__container">
			<div className="add-on__title-container">
				<div className="add-on__main-info">
					<div className="add-on__header">
						<div className="add-on__title">
							<div className="icon__container" style={{ backgroundColor: iconBg }}>
								<Icon name={iconName || 'library_add'} useMaterialIcons />
							</div>
							<h5>{name}</h5>
							{tooltip && <CustomTooltip key="test">{tooltip}</CustomTooltip>}
						</div>
						<div className="add-on__restrictions">
							<p className="price">{formatCurrency(staticPrice ?? 0)} each</p>
							<If condition={!removable}>
								<p>
									<If condition={stringNotEmpty(removalInformation)}>
										<CustomTooltip content={removalInformation} />
									</If>
									<If condition={stringIsEmpty(removalInformation)}>
										<Icon name="warning" />
									</If>
									{stringNotEmpty(removalTitle) ? removalTitle : 'Non-refundable'}
								</p>
							</If>
						</div>
					</div>
					<If condition={stringNotEmpty(information) && !displayInfoInTooltip}>
						<p className="add-on__description">{information}</p>
					</If>
				</div>
			</div>
			{children}
		</div>
	);
}
